import React, { useMemo, useRef, useState } from 'react';

const tree = {
    id: 'start',
    label: 'Start',
    children: [
        {
            id: 'platform',
            label: 'Platform Engineering',
            children: [
                {
                    id: 'infrastructure',
                    label: 'Infrastructure',
                    children: [
                        {
                            id: 'kubernetes',
                            label: 'Kubernetes',
                            children: [
                                { id: 'load-balancers', label: 'Load Balancers' },
                                { id: 'deployments', label: 'Deployments' },
                                { id: 'statefulsets', label: 'StatefulSets' },
                                { id: 'pods', label: 'Pods' },
                                { id: 'cronjobs', label: 'CronJobs' },
                                { id: 'volumes', label: 'Volumes' },
                                { id: 'pvcs', label: 'PersistentVolumeClaims' },
                                { id: 'csi-drivers', label: 'CSI Drivers' },
                                { id: 'secrets', label: 'Secrets' },
                                { id: 'configmaps', label: 'ConfigMaps' },
                                { id: 'kind', label: 'kind' },
                                {
                                    id: 'helm-charts',
                                    label: 'Helm Charts',
                                    children: [
                                        { id: 'helm-grafana', label: 'Helm - Grafana' },
                                        { id: 'helm-istio', label: 'Helm - Istio' },
                                        { id: 'helm-airflow', label: 'Helm - Airflow' },
                                        { id: 'helm-prometheus', label: 'Helm - Prometheus' },
                                        { id: 'helm-argocd', label: 'Helm - ArgoCD' },
                                    ],
                                },
                            ],
                        },
                        { id: 'knative', label: 'Knative' },
                        { id: 'serverless', label: 'Serverless' },
                        { id: 'spark', label: 'Spark' },
                        {
                            id: 'databases',
                            label: 'Databases',
                            children: [
                                { id: 'mysql', label: 'MySQL' },
                                {
                                    id: 'postgres',
                                    label: 'Postgres',
                                    children: [
                                        { id: 'pgadmin', label: 'pgAdmin' },
                                        { id: 'pgsql', label: 'pgsql' },
                                    ],
                                },
                                { id: 'sqlite', label: 'SQLite' },
                                { id: 'duckdb', label: 'DuckDB' },
                                { id: 'parquet', label: 'Parquet' },
                                { id: 'iceberg', label: 'Iceberg' },
                                {
                                    id: 'sql',
                                    label: 'SQL',
                                    children: [
                                        { id: 'sql-views', label: 'Views' },
                                        { id: 'sql-matviews', label: 'Matviews' },
                                        { id: 'sql-tables', label: 'Tables' },
                                        { id: 'sql-backups', label: 'Backups' },
                                        { id: 'sql-indexes', label: 'Indexes' },
                                        { id: 'sql-partitioning', label: 'Partitioning' },
                                        { id: 'sql-clustering', label: 'Clustering' },
                                        { id: 'sql-locks', label: 'Locks' },
                                        { id: 'sql-vacuuming', label: 'Vacuuming' },
                                    ],
                                },
                                { id: 'flyway', label: 'Flyway' },
                                { id: 'db-alembic', label: 'Alembic' },
                                { id: 'elasticsearch', label: 'Elasticsearch' },
                                { id: 'datagrip', label: 'DataGrip' },
                                { id: 'neo4j', label: 'Neo4j' },
                            ],
                        },
                        {
                            id: 'caches',
                            label: 'Caches',
                            children: [
                                { id: 'redis', label: 'Redis' },
                                { id: 'memcached', label: 'Memcached' },
                            ],
                        },
                        {
                            id: 'networking',
                            label: 'Networking',
                            children: [
                                { id: 'net-vpc', label: 'VPC' },
                                { id: 'net-subnets', label: 'Subnets' },
                                { id: 'net-firewall-rules', label: 'Firewall Rules' },
                                { id: 'net-nics', label: 'NICs' },
                                { id: 'net-direct-connects', label: 'Direct Connects' },
                                { id: 'net-dns', label: 'DNS' },
                                { id: 'net-tls', label: 'TLS' },
                                { id: 'net-http', label: 'HTTP' },
                            ],
                        },
                        {
                            id: 'logging',
                            label: 'Logging',
                            children: [{ id: 'otel', label: 'OTel' }],
                        },
                        { id: 'iam', label: 'IAM' },
                        {
                            id: 'message-brokers',
                            label: 'Message Brokers',
                            children: [{ id: 'kafka', label: 'Kafka' }],
                        },
                    ],
                },
                {
                    id: 'devops',
                    label: 'DevOps',
                    children: [
                        {
                            id: 'artifact-registries',
                            label: 'Artifact Registries',
                            children: [
                                { id: 'pypi', label: 'PyPI' },
                                { id: 'docker-registries', label: 'Docker Registries' },
                            ],
                        },
                        {
                            id: 'linux',
                            label: 'Linux',
                            children: [
                                { id: 'bash', label: 'Bash' },
                                {
                                    id: 'zsh',
                                    label: 'Zsh',
                                    children: [
                                        { id: 'zshrc', label: '.zshrc' },
                                        { id: 'zprofile', label: '.zprofile' },
                                    ],
                                },
                            ],
                        },
                        { id: 'oci-containers', label: 'OCI Containers' },
                        { id: 'circleci', label: 'CircleCI' },
                        { id: 'azure-devops', label: 'Azure DevOps' },
                        { id: 'terraform', label: 'Terraform' },
                        // Kept last so it sits next to GitHub, its second parent.
                        {
                            id: 'github-actions',
                            label: 'GitHub Actions',
                            children: [
                                { id: 'docker-runners', label: 'Docker Runners' },
                                { id: 'python-runners', label: 'Python Runners' },
                                { id: 'bash-runners', label: 'Bash Runners' },
                            ],
                        },
                    ],
                },
                { id: 'github', label: 'GitHub' },
                {
                    id: 'cloud',
                    label: 'Cloud',
                    children: [
                        {
                            id: 'aws',
                            label: 'AWS',
                            children: [
                                { id: 'aws-s3', label: 'S3' },
                                { id: 'aws-eks', label: 'EKS' },
                                { id: 'aws-route53', label: 'Route 53' },
                                { id: 'aws-vpc', label: 'VPC' },
                                { id: 'aws-ecr', label: 'ECR' },
                                { id: 'aws-athena', label: 'Athena' },
                                { id: 'aws-bedrock', label: 'Bedrock' },
                                { id: 'aws-bedrock-agentcore', label: 'Bedrock AgentCore' },
                            ],
                        },
                        {
                            id: 'nvidia',
                            label: 'Nvidia',
                            children: [
                                { id: 'runai', label: 'Run:ai' },
                                { id: 'cuda', label: 'CUDA' },
                                { id: 'nvidia-nims', label: 'NIMs' },
                                { id: 'nemo-helix', label: 'NeMo Helix' },
                                { id: 'nvcc', label: 'nvcc' },
                                { id: 'nvkind', label: 'nvkind' },
                            ],
                        },
                        { id: 'snowflake', label: 'Snowflake' },
                        { id: 'azure', label: 'Azure' },
                        { id: 'databricks', label: 'Databricks' },
                        {
                            id: 'google-cloud',
                            label: 'Google Cloud',
                            children: [
                                { id: 'gcp-pubsub', label: 'Pub/Sub' },
                                { id: 'gcp-cloud-sql', label: 'Cloud SQL' },
                                { id: 'gcp-cloud-run', label: 'Cloud Run' },
                                { id: 'gcp-artifact-registry', label: 'Artifact Registry' },
                                { id: 'gcp-bigquery', label: 'BigQuery' },
                                { id: 'gcp-cloud-scheduler', label: 'Cloud Scheduler' },
                                { id: 'gcp-managed-airflow', label: 'Managed Airflow' },
                                { id: 'gcp-gemini-enterprise', label: 'Gemini Enterprise' },
                                { id: 'gcp-firestore', label: 'Firestore' },
                                { id: 'gcp-memorystore', label: 'Memorystore' },
                                { id: 'gcp-eventarc', label: 'Eventarc' },
                                { id: 'gcp-model-garden', label: 'Model Garden' },
                            ],
                        },
                    ],
                },
                { id: 'data-governance', label: 'Data Governance' },
            ],
        },
        {
            id: 'mobile',
            label: 'Mobile Development',
            children: [
                {
                    id: 'ios',
                    label: 'iOS',
                    children: [
                        { id: 'app-store-connect', label: 'App Store Connect' },
                        { id: 'xcode', label: 'Xcode' },
                        { id: 'swiftui', label: 'SwiftUI' },
                        { id: 'swift', label: 'Swift' },
                        { id: 'ios-widgets', label: 'Widget' },
                    ],
                },
                {
                    id: 'android',
                    label: 'Android Development',
                    children: [{ id: 'kotlin', label: 'Kotlin' }],
                },
            ],
        },
        {
            id: 'gaming',
            label: 'Gaming Development',
            children: [
                { id: 'unity', label: 'Unity' },
                { id: 'unreal-engine', label: 'Unreal Engine' },
                { id: 'godot', label: 'Godot' },
                { id: 'steam-store', label: 'Steam Store' },
            ],
        },
        {
            id: 'research',
            label: 'Researcher',
            children: [
                {
                    id: 'inference',
                    label: 'Inference',
                    children: [
                        { id: 'vllm', label: 'vLLM' },
                        { id: 'sglang', label: 'SGLang' },
                        { id: 'dynamo', label: 'Dynamo Platform' },
                        // Kept last so it sits next to Training, its second parent.
                        { id: 'ml-pytorch', label: 'PyTorch' },
                    ],
                },
                {
                    id: 'training',
                    label: 'Training',
                    children: [
                        { id: 'sklearn', label: 'sklearn' },
                        { id: 'pyspark', label: 'PySpark' },
                    ],
                },
                {
                    id: 'model-architectures',
                    label: 'Model Architectures',
                    children: [
                        { id: 'transformers', label: 'Transformers' },
                        { id: 'xgboost', label: 'XGBoost' },
                    ],
                },
                {
                    id: 'supervised-learning',
                    label: 'Supervised Learning',
                    children: [{ id: 'tree-based-models', label: 'Tree-Based Models' }],
                },
                {
                    id: 'unsupervised-learning',
                    label: 'Unsupervised Learning',
                    children: [{ id: 'dbscan', label: 'DBSCAN' }],
                },
                { id: 'statistics', label: 'Statistics' },
                {
                    id: 'data-visualization',
                    label: 'Data Visualization',
                    children: [
                        { id: 'matplotlib', label: 'Matplotlib' },
                        { id: 'tableau', label: 'Tableau' },
                        { id: 'dataviz-d3', label: 'D3' },
                        { id: 'power-bi', label: 'Power BI' },
                    ],
                },
                {
                    id: 'rag',
                    label: 'RAG',
                    children: [
                        { id: 'rag-vectors', label: 'Vectors' },
                        { id: 'rag-embeddings', label: 'Embeddings' },
                    ],
                },
            ],
        },
        {
            id: 'data-engineering',
            label: 'Data Engineering',
            children: [{ id: 'airflow', label: 'Airflow' }],
        },
        {
            id: 'frontend',
            label: 'Frontend Engineering',
            children: [
                { id: 'react', label: 'React' },
                { id: 'd3', label: 'D3' },
                {
                    id: 'auth',
                    label: 'Authentication and Authorization',
                    children: [
                        { id: 'cognito', label: 'Cognito' },
                        { id: 'firebase', label: 'Firebase' },
                        { id: 'authentication', label: 'Authentication' },
                        { id: 'authorization', label: 'Authorization' },
                        { id: 'mfa', label: 'MFA' },
                        { id: 'service-accounts', label: 'Service Accounts' },
                        { id: 'api-keys', label: 'API Keys' },
                        { id: 'oidc', label: 'OpenID Connect (OIDC)' },
                        { id: 'sso', label: 'SSO' },
                    ],
                },
            ],
        },
        {
            id: 'backend',
            label: 'Backend Development',
            children: [
                {
                    id: 'protocols',
                    label: 'Protocols',
                    children: [
                        { id: 'protocol-rest', label: 'REST' },
                        { id: 'protocol-websockets', label: 'WebSockets' },
                        { id: 'protocol-graphql', label: 'GraphQL' },
                        { id: 'protocol-streaming-http', label: 'Streaming HTTP' },
                        { id: 'protocol-grpc', label: 'gRPC' },
                    ],
                },
                { id: 'short-polling', label: 'Short Polling' },
                { id: 'long-polling', label: 'Long Polling' },
                { id: 'choreography', label: 'Choreography' },
                { id: 'orchestration', label: 'Orchestration' },
                { id: 'cors', label: 'CORS' },
                { id: 'mcp', label: 'MCP' },
            ],
        },
        {
            id: 'security',
            label: 'Security',
            children: [
                { id: 'security-scanning', label: 'Security Scanning Tools' },
                { id: 'pen-testing', label: 'Pen Testing' },
                { id: 'cves', label: 'CVEs' },
                {
                    id: 'encryption',
                    label: 'Encryption',
                    children: [
                        { id: 'md5', label: 'MD5' },
                        { id: 'sha', label: 'SHA' },
                        { id: 'bcrypt', label: 'bcrypt' },
                    ],
                },
            ],
        },
        {
            id: 'basics',
            label: 'Software Engineering Basics',
            children: [
                {
                    id: 'clis',
                    label: 'CLIs',
                    children: [
                        { id: 'k8s', label: 'k8s' },
                        { id: 'helm', label: 'helm' },
                        { id: 'make', label: 'make' },
                        { id: 'curl', label: 'curl' },
                        { id: 'grep', label: 'grep' },
                        { id: 'ls', label: 'ls' },
                        { id: 'gcloud', label: 'gcloud' },
                        { id: 'aws-cli', label: 'aws cli' },
                        { id: 'az-cli', label: 'az-cli' },
                        { id: 'psql', label: 'psql' },
                        { id: 'pg-dump', label: 'pg_dump' },
                        { id: '1password-cli', label: '1password cli' },
                        { id: 'uv', label: 'uv' },
                        { id: 'docker-cli', label: 'docker' },
                        { id: 'tree-cli', label: 'tree' },
                        { id: 'terraform-cli', label: 'terraform' },
                        { id: 'golang', label: 'golang' },
                        { id: 'rust', label: 'rust' },
                        { id: 'vim', label: 'vim' },
                        { id: 'nano', label: 'nano' },
                        {
                            id: 'networking-cli',
                            label: 'Networking',
                            children: [{ id: 'nslookup', label: 'nslookup' }],
                        },
                        {
                            id: 'python',
                            label: 'python',
                            children: [
                                { id: 'pytest', label: 'pytest' },
                                { id: 'numpy', label: 'numpy' },
                                { id: 'pandas', label: 'pandas' },
                                { id: 'pytorch', label: 'pytorch' },
                                { id: 'fastapi', label: 'fastapi' },
                                { id: 'uvicorn', label: 'uvicorn' },
                                { id: 'argparse', label: 'argparse' },
                                { id: 'black', label: 'black' },
                                { id: 'jinja2', label: 'jinja2' },
                                { id: 'py-airflow', label: 'airflow' },
                                { id: 'pyyaml', label: 'pyyaml' },
                                { id: 'python-dotenv', label: 'python-dotenv' },
                                { id: 'httpx', label: 'httpx' },
                                { id: 'requests', label: 'requests' },
                                { id: 'alembic', label: 'alembic' },
                                { id: 'psycopg2-binary', label: 'psycopg2-binary' },
                                { id: 'websockets', label: 'websockets' },
                                { id: 'gspread', label: 'gspread' },
                            ],
                        },
                    ],
                },
            ],
        },
    ],
};

// Extra edges for nodes with more than one parent. The node is placed under its parent in `tree`,
// and these draw the additional connections.
const extraLinks = [
    { from: 'github', to: 'github-actions' },
    { from: 'research', to: 'airflow' },
    { from: 'training', to: 'ml-pytorch' },
    { from: 'backend', to: 'auth' },
];

// Distance from the root for each depth.
const RADII = [0, 280, 460, 650, 810, 960];
const NODE_SIZES = [50, 40, 28, 20, 16, 14];
const NODE_COLORS = ['#374151', '#3b82f6', '#10b981', '#f59e0b', '#ec4899', '#a78bfa'];
// Every top-level branch gets at least this share of the circle, however large the others grow.
const MIN_TOP_SHARE = 0.1;
// Second-level nodes, and deeper nodes that have children (drawn larger than leaf dots), count as at
// least this many leaves, so they don't touch their siblings.
const MIN_SECOND_WEIGHT = 2;
// Leaves below the top level are drawn as small dots so dense branches fit.
const MAX_LEAF_SIZE = 14;
// Crowded nodes shrink so every node keeps at least this gap (in graph units) to its nearest neighbour,
// but never below MIN_NODE_SIZE.
const NODE_GAP = 6;
const MIN_NODE_SIZE = 6;
// Dock-style magnification: nodes within this distance of the cursor (in graph units) grow,
// up to (1 + MAGNIFY_BOOST) times their size directly under it.
const MAGNIFY_RADIUS = 220;
const MAGNIFY_BOOST = 1.2;
const PADDING = 160;

const countLeaves = (node) =>
    node.children && node.children.length ? node.children.reduce((sum, child) => sum + countLeaves(child), 0) : 1;

const isLeaf = (node) => !node.children || node.children.length === 0;

const TOTAL_LEAVES = countLeaves(tree);

const weight = (node, depth) => {
    const leaves = countLeaves(node);
    if (depth === 1) return Math.max(leaves, TOTAL_LEAVES * MIN_TOP_SHARE);
    if (depth === 2 || !isLeaf(node)) return Math.max(leaves, MIN_SECOND_WEIGHT);
    return leaves;
};

// Walk the tree and give every node a position. Each node owns a wedge of the circle sized by how many
// leaves sit under it, and splits that wedge between its children the same way, so branches never overlap.
function layout(node, depth = 0, start = 0, end = 2 * Math.PI, parent = null, out = []) {
    const radius = RADII[Math.min(depth, RADII.length - 1)];
    const angle = (start + end) / 2;
    const placed = { ...node, depth, angle, parent, x: radius * Math.cos(angle), y: radius * Math.sin(angle) };
    out.push(placed);

    const children = node.children || [];
    const total = children.reduce((sum, child) => sum + weight(child, depth + 1), 0);
    let cursor = start;
    children.forEach((child) => {
        const span = ((end - start) * weight(child, depth + 1)) / total;
        layout(child, depth + 1, cursor, cursor + span, placed, out);
        cursor += span;
    });
    return out;
}

// Deeper nodes get their label rotated along their edge, so crowded neighbours never overlap:
// leaves point away from the centre, parents point back toward their own parent.
// Top-level nodes and second-level parents keep it underneath.
function labelProps(node, size) {
    if (node.depth === 0) {
        return { x: node.x, y: node.y, textAnchor: 'middle', dominantBaseline: 'middle' };
    }
    const inward = !isLeaf(node);
    if (node.depth === 1 || (inward && node.depth === 2)) {
        return { x: node.x, y: node.y + size + 18, textAnchor: 'middle' };
    }
    const offset = (size + 8) * (inward ? -1 : 1);
    const x = node.x + offset * Math.cos(node.angle);
    const y = node.y + offset * Math.sin(node.angle);
    const degrees = (node.angle * 180) / Math.PI;
    // Flip labels on the left half so they read left-to-right instead of upside down.
    const flip = Math.cos(node.angle) < 0;
    return {
        x,
        y,
        textAnchor: flip !== inward ? 'end' : 'start',
        dominantBaseline: 'middle',
        transform: `rotate(${flip ? degrees + 180 : degrees} ${x} ${y})`,
    };
}

const preferredSizeFor = (node) => {
    const level = Math.min(node.depth, NODE_SIZES.length - 1);
    return node.depth >= 2 && isLeaf(node) ? Math.min(NODE_SIZES[level], MAX_LEAF_SIZE) : NODE_SIZES[level];
};

// Shrink nodes that sit close to a neighbour. Each node may use up to half the distance to its nearest
// neighbour (less the gap), so two crowded nodes can never overlap, while roomy nodes keep their full size.
function fitSizes(nodes) {
    const sizes = {};
    nodes.forEach((node) => {
        const nearest = nodes.reduce(
            (min, other) => (other === node ? min : Math.min(min, Math.hypot(node.x - other.x, node.y - other.y))),
            Infinity
        );
        const room = nearest / 2 - NODE_GAP / 2;
        sizes[node.id] = Math.max(MIN_NODE_SIZE, Math.min(preferredSizeFor(node), room));
    });
    return sizes;
}

// Breadcrumb from Start down to this node, e.g. "Start › Platform Engineering › DevOps".
function pathTo(node) {
    const labels = [];
    for (let current = node; current; current = current.parent) labels.unshift(current.label);
    return labels.join(' › ');
}

export default function SkillGraph() {
    const wrapperRef = useRef(null);
    const svgRef = useRef(null);
    const [hovered, setHovered] = useState(null);
    const [pointer, setPointer] = useState(null);

    // The tree is static, so lay it out and fit node sizes once rather than on every pointer move.
    const { nodes, sizes } = useMemo(() => {
        const totalWeight = tree.children.reduce((sum, child) => sum + weight(child, 1), 0);
        const firstSpan = (2 * Math.PI * weight(tree.children[0], 1)) / totalWeight;
        const start = -Math.PI / 2 - firstSpan / 2;
        const placed = layout(tree, 0, start, start + 2 * Math.PI);
        return { nodes: placed, sizes: fitSizes(placed) };
    }, []);
    const byId = Object.fromEntries(nodes.map((n) => [n.id, n]));
    const edges = [
        ...nodes.filter((n) => n.parent).map((n) => ({ from: n.parent, to: n })),
        ...extraLinks.map((link) => ({ from: byId[link.from], to: byId[link.to] })),
    ];
    const xs = nodes.map((n) => n.x);
    const ys = nodes.map((n) => n.y);
    const minX = Math.min(...xs) - PADDING;
    const minY = Math.min(...ys) - PADDING;
    const width = Math.max(...xs) - minX + PADDING;
    const height = Math.max(...ys) - minY + PADDING;

    // Track the cursor in graph coordinates so nearby nodes can be magnified.
    const trackPointer = (event) => {
        const svg = svgRef.current;
        const point = svg.createSVGPoint();
        point.x = event.clientX;
        point.y = event.clientY;
        const { x, y } = point.matrixTransform(svg.getScreenCTM().inverse());
        setPointer({ x, y });
    };

    // Smooth falloff: full boost under the cursor, easing to none at MAGNIFY_RADIUS.
    const scaleFor = (node) => {
        if (!pointer) return 1;
        const distance = Math.hypot(node.x - pointer.x, node.y - pointer.y);
        const closeness = Math.max(0, 1 - distance / MAGNIFY_RADIUS);
        return 1 + MAGNIFY_BOOST * closeness * closeness;
    };

    const baseSizeFor = (node) => sizes[node.id];

    // Draw magnified nodes last so they sit on top of their neighbours.
    const drawOrder = [...nodes].sort((a, b) => scaleFor(a) - scaleFor(b));

    // Anchor the tooltip to the top of the hovered circle at its current (magnified) size,
    // converted from graph units to pixels relative to the wrapper.
    let tooltipAnchor = null;
    if (hovered && svgRef.current && wrapperRef.current) {
        const svg = svgRef.current;
        const point = svg.createSVGPoint();
        point.x = hovered.x;
        point.y = hovered.y - baseSizeFor(hovered) * scaleFor(hovered);
        const screen = point.matrixTransform(svg.getScreenCTM());
        const wrapper = wrapperRef.current.getBoundingClientRect();
        tooltipAnchor = { x: screen.x - wrapper.left, y: screen.y - wrapper.top };
    }

    return (
        <div className="mx-auto mt-8 px-4 text-center">
            <h1 className="font-sans text-3xl font-semibold mb-6">Skill Graph</h1>
            <div ref={wrapperRef} className="relative w-full mx-auto">
            <svg
                ref={svgRef}
                viewBox={`${minX} ${minY} ${width} ${height}`}
                className="w-full"
                onMouseMove={trackPointer}
                onMouseLeave={() => setPointer(null)}
            >
                {edges.map(({ from, to }) => (
                    <line
                        key={`edge-${from.id}-${to.id}`}
                        x1={from.x}
                        y1={from.y}
                        x2={to.x}
                        y2={to.y}
                        stroke="#9ca3af"
                        strokeWidth="2"
                    />
                ))}

                {drawOrder.map((node) => {
                    const level = Math.min(node.depth, NODE_SIZES.length - 1);
                    const scale = scaleFor(node);
                    const size = baseSizeFor(node) * scale;
                    const isRoot = node.depth === 0;
                    return (
                        <g
                            key={node.id}
                            className="cursor-pointer"
                            onMouseEnter={() => setHovered(node)}
                            // Also catch nodes that appear or grow under a resting cursor, where no enter event fires.
                            onMouseMove={() => (!hovered || hovered.id !== node.id) && setHovered(node)}
                            onMouseLeave={() => setHovered(null)}
                        >
                            <circle
                                className="skill-node"
                                cx={node.x}
                                cy={node.y}
                                r={size}
                                fill={NODE_COLORS[level]}
                                stroke={isRoot ? '#e5e7eb' : 'none'}
                                strokeWidth="2"
                            />
                            <text
                                {...labelProps(node, size)}
                                fill={isRoot ? '#fff' : 'currentColor'}
                                fontSize={(isRoot ? 18 : 15 - level) * scale}
                                fontWeight={isRoot ? 600 : 400}
                                // Dark halo keeps labels readable where an edge passes behind them.
                                stroke={isRoot ? 'none' : '#000'}
                                strokeWidth="4"
                                paintOrder="stroke"
                            >
                                {node.label}
                            </text>
                        </g>
                    );
                })}
            </svg>

            {tooltipAnchor && (
                <div
                    className="absolute pointer-events-none z-20"
                    style={{ left: tooltipAnchor.x, top: tooltipAnchor.y, transform: 'translate(-50%, calc(-100% - 12px))' }}
                >
                    {/* Keyed by node so the genie animation replays when moving between nodes. */}
                    <div
                        key={hovered.id}
                        className="skill-tooltip whitespace-nowrap rounded-xl border border-white/20 bg-gray-900/95 px-4 py-3 text-left text-base text-gray-100 shadow-xl"
                    >
                        <div className="text-xl font-semibold">{hovered.label}</div>
                        <div className="text-sm text-gray-400">{pathTo(hovered)}</div>
                        {!isLeaf(hovered) && (
                            <div className="mt-1 text-sm text-gray-300">
                                {countLeaves(hovered)} skill{countLeaves(hovered) === 1 ? '' : 's'}
                            </div>
                        )}
                        {extraLinks
                            .filter((link) => link.to === hovered.id)
                            .map((link) => (
                                <div key={link.from} className="mt-1 text-sm text-gray-300">
                                    Also under {byId[link.from].label}
                                </div>
                            ))}
                    </div>
                </div>
            )}
            </div>
        </div>
    );
}
